var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.853 8.625L16.7358 3.74219C17.3706 3.15625 17.3706 2.17969 16.7358 1.59375L15.6616 0.519531C15.0757 -0.115234 14.0991 -0.115234 13.5132 0.519531L8.63037 5.40234L3.69873 0.519531C3.11279 -0.115234 2.13623 -0.115234 1.55029 0.519531L0.476074 1.59375C-0.158691 2.17969 -0.158691 3.15625 0.476074 3.74219L5.35889 8.625L0.476074 13.5566C-0.158691 14.1426 -0.158691 15.1191 0.476074 15.7051L1.55029 16.7793C2.13623 17.4141 3.11279 17.4141 3.69873 16.7793L8.63037 11.8965L13.5132 16.7793C14.0991 17.4141 15.0757 17.4141 15.6616 16.7793L16.7358 15.7051C17.3706 15.1191 17.3706 14.1426 16.7358 13.5566L11.853 8.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.e559db7a091df1d43cfbded83d838168.svg";
export { ForwardRef as ReactComponent };